import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AmbassadorProvider } from '@context/context'
import NotificationWrapper from '@corecomponents/notification/NotificationWrapper'
import * as Sentry from '@sentry/react'

const queryClient = new QueryClient()

Sentry.init({
  dsn: 'https://ee0cbc26fb8faaab92fbfab1e6972703@sentry-web.penpencil.co/34',
  integrations: [Sentry.browserTracingIntegration()],
  environment: process.env.REACT_APP_PUBLIC_ENVIRONMENT,
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 10% of the transactions
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <AmbassadorProvider>
        <NotificationWrapper />
        <App />
      </AmbassadorProvider>
    </React.StrictMode>
  </QueryClientProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
